<template>
<div class="sideInfo">
  <div class="sideInfo_title">
    {{title}}
    <div class="btnsArea">
      <slot name="btns"/>
    </div>
  </div>
  <div class="sideInfo_content">
    <template v-if="!edit">
      <slot/>
    </template>
    <template v-else>
      <slot name="edit"/>
      <Btns :style="{marginTop: '25px'}" @save="$emit('save')" @cancel="$emit('cancel')"/>
    </template>
  </div>
</div>
</template>

<script>
import Btns from '../btn/btns.vue'
export default {
  props: ['edit', 'title'],
  components: {
    Btns
  }

}
</script>

<style lang="scss" scoped>
.btnsArea {
  position: absolute;
  right: 15px
}
.sideInfo {
  position: relative;
  width: -webkit-fill-available;
  min-height: fit-content;
  height: fit-content;
  border: 1px solid #989898;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  .sideInfo_title {
    min-height: 45px;
    height: fit-content;
    background-color: var(--color-pri);
    color: #FFFFFF;
    text-align: start;
    padding-inline: 28px;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .sideInfo_content {
    padding: 25px 28px 24px;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
  }
}
</style>
